<template>
  <select v-model="selectedStatus" @change="onSelectChange" class="custom-select w-25">
    <option :value="status.key" v-for="status in allStatus" :key="status.key">{{ status.name }}</option>
  </select>
</template>

<script>
export default {
  data() {
    return {
      allStatus: [
        {
          key: '',
          name: 'Filtrer par statut'
        },
        {
          key: 'invoice_received',
          name: 'Facture reçue'
        },
        {
          key: 'billing_call',
          name: 'Appel à facturation'
        },
        {
          key: 'payment_done',
          name: 'Paiement effectué'
        },
        {
          key: 'deleted',
          name: 'Facture Supprimée'
        }
      ],
      selectedStatus: '',
      url: '',
    }
  },

  mounted() {
    this.url =  new URL(window.location.href)

    if (this.url.search.length) {
      const query = new URLSearchParams(this.url.search)

      const status = query.get('status')

      if (status) {
        this.selectedStatus = query.get('status')
      }
    }
  },

  methods: {
    onSelectChange() {
      const params = new URLSearchParams(this.url.search)

      params.set('status', this.selectedStatus)

      this.url.search = params.toString();

      window.location.replace(this.url.toString());
    }
  }
}
</script>
